// extracted by mini-css-extract-plugin
export default {"icon":"MetadataItem_icon__Q0gVj","link":"MetadataItem_link__FuLGC","pathOverflowIcon":"MetadataItem_pathOverflowIcon__E+xeD"};